export const STRINGS_CULTIVARES = { 
    BOTAO_CONFIRMAR_ASSINATURAS: "Confirmar",
    TITULO_CONFIRMAR_ASSINATURAS: "Confirmar Submissão de Arquivos Assinados",
    CONFIRMAR_ASSINATURAS: "ATENÇÃO! Não é permitido submeter ao regulatório uma solicitação sem ter o Relatório Técnico e a Tabela de Descritores assinados. Favor providenciar ambos para seguir. ",
};